<template>
  <div class="sub-header-title">
    <h2>{{ route.matched[0].meta.breadcrumbName }}</h2>
    <h3>{{ route.matched[0].meta.description }}</h3>
  </div>
  <div class="sub-header-tab">
    <ul class="sub-header-tab">
      <li
        v-for="(child, idx) in childMenu as Array<RouteRecordRaw>"
        :key="`${child.path}-${idx}`"
        :class="{
          on: route.name === child.name || child.name === route?.meta.subName,
        }"
      >
        <router-link
          v-if="child?.meta?.breadcrumbName"
          :class="{
            active:
              route.name === child.name || child.name === route?.meta.subName,
          }"
          :to="{ name: child.name }"
          >{{ child?.meta.breadcrumbName }}</router-link
        >
      </li>
    </ul>
  </div>
</template>
<script setup lang="ts">
import { RouteRecordRaw, useRoute } from 'vue-router';
import { computed } from 'vue';
import { useUserStore } from '@stores';

const userStore = useUserStore();
const route = useRoute();
console.log('route', route);
const isAdmin = computed(() => userStore.grant === 'WEB_ADMIN');
const childMenu = computed(() =>
  route?.matched[0]?.children.filter((f) => {
    if (f?.meta?.isAdmin) {
      return isAdmin.value && f?.meta?.breadcrumb;
    } else {
      return f?.meta?.breadcrumb;
    }
  })
);
</script>

<style scoped lang="scss">
.sub-header-title {
  padding: 0 16px;
}

.sub-header-title h2 {
  font-size: var(--f20);
  font-weight: bold;
  letter-spacing: -0.5px;
  padding-bottom: 10px;
}

.sub-header-title h3 {
  font-size: var(--f12);
  color: #666;
  padding-bottom: 40px;
}

.sub-header-tab {
  width: 100%;
  position: relative;
  border-bottom: 1px solid #ddd;
  z-index: 0;
}

.sub-header-tab ul {
  padding: 0 16px;
  display: flex;
  align-items: center;
  gap: 0 32px;
  overflow-x: auto;
  position: relative;
  z-index: 2;
}

.sub-header-tab ul li {
  flex: 0 0 auto;
  font-weight: 500;
  color: #222;
  position: relative;
  cursor: pointer;
}

.sub-header-tab ul li a {
  padding-bottom: 14px;
  display: block;
}

.sub-header-tab ul li.on {
  color: var(--color-main);
  font-weight: bold;
  position: relative;
}

.sub-header-tab ul li.on::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background-color: var(--color-main);
}
</style>
